import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  BadGateway,
  Forbidden,
  UnexpectedError,
  BadRequestError,
  NotFound,
  InvalidCredentialsError,
} from '~/domain/errors';
import { UpdateInstantAppointment } from '~/domain/usecases/appointment/remote';

export class RemoteUpdateInstantAppointment
  implements UpdateInstantAppointment
{
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateInstantAppointment.Model>;

  constructor(
    url: string,
    httClient: HttpClient<UpdateInstantAppointment.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  updateInstantAppointment = async (
    params: UpdateInstantAppointment.Params,
  ): Promise<UpdateInstantAppointment.Model> => {
    const { appointmentId, otherProfessionalId, ...rest } = params;

    const httpResponse = await this.httpClient.request({
      url: `${this.url}${appointmentId}/otherProfessionals/${otherProfessionalId}`,
      method: 'patch',
      body: rest,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return 'OI';
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
